import styles from './Dates.module.scss';

const privacyPolicyDates = [
  {
    id: 1,
    headline: 'Version update date:',
    date: '[ 2nd JUN 2025 ]',
  },
  {
    id: 2,
    headline: 'Version effective date:',
    date: '[ 2nd JUN 2025 ]',
  },
];

const formatDate = (isoString) => {
  const date = new Date(isoString);
  const day = date.getDate();
  const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
  const year = date.getFullYear();

  const suffix = (day) => {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  return `${day}${suffix(day)} ${month.toUpperCase()} ${year}`;
};

export default function PrivacyPolicyDates({ fields }) {
  return (
    <ul className={styles.list}>
      <li className={styles.item}>
        <span className={styles.headline}>Version update date:</span>
        <p className={styles.date}>[ {formatDate(fields.versionUpdateDate.value)} ]</p>
      </li>
      <li className={styles.item}>
        <span className={styles.headline}>Version effective date:</span>
        <p className={styles.date}>[ {formatDate(fields.versionEffectiveDate.value)} ]</p>
      </li>
    </ul>
  );
}
